import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const AmexShortIcon = (props: IconProps) => (
  <StyledIcon
    width="23"
    height="24"
    viewBox="0 0 23 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4265_73353)">
      <path
        d="M21.1501 22.0085H11.1506H1.15039V12.0857V2.00879H11.1452H21.1501V12.0685V22.0085Z"
        fill="white"
      />
      <path
        d="M1.15039 2.0083V22.008H21.1501V18.842H18.5026L17.3623 17.6015L16.2227 18.842H8.4304V12.495H5.86347L9.08973 5.18217H12.1494L13.0434 7.12103V5.18217H16.7366L17.5625 7.25401L18.39 5.18217H21.1501V2.0083H1.15039ZM18.9961 6.18797L18.0294 8.50149L17.5625 9.64809L17.0963 8.50149L16.1242 6.18797H13.9764V11.5471L11.623 6.18797H9.79677L7.42928 11.5471H8.97632L9.40414 10.5006H11.9891L12.4169 11.5471H13.9764H15.3366V8.32785L15.3233 7.5426L15.6369 8.32785L16.9571 11.5471H18.1631L19.4842 8.32785L19.7962 7.5426L19.7829 8.32785V11.5471H21.1423V6.18797H18.9961ZM10.3701 8.1206L10.6892 7.30093L11.0106 8.1206L11.5229 9.3673H9.86325L10.3701 8.1206ZM19.043 12.495L17.3959 14.2485L15.7566 12.495H13.9764L16.5097 15.1746L13.9764 17.8346H15.7159L17.3623 16.0811L19.0031 17.8346H20.7825L18.2507 15.1543L20.7825 12.495H19.043ZM9.49643 12.495V17.8346H13.9764V16.6958H10.8558V15.7354H13.9107V14.6021H10.8558V13.6361H13.9764V12.495H9.49643ZM19.6421 15.1409L21.1501 16.6958V13.6221L19.6421 15.1409Z"
        fill="#006FCF"
      />
    </g>
    <defs>
      <clipPath id="clip0_4265_73353">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(1.14062 2)"
        />
      </clipPath>
    </defs>
  </StyledIcon>
)
